import { FC } from "react";

import { PopupImportImageUrlFieldCell } from "./PopupImportImageUrlFieldCell";

type Props = {
  base: string;
};

/** 再表示ボタン用画像: URL field + thumbnail (import uses URLs only; no file upload). */
export const PopupImportDisplayPopupAgainImageCell: FC<Props> = ({ base }) => {
  const imageUrlName = `${base}.popup.displayPopupAgainImage.imageUrl`;
  return <PopupImportImageUrlFieldCell name={imageUrlName} />;
};
